"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbDynamicText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("../Typography/Typography");
const link_1 = __importDefault(require("next/link"));
function BreadcrumbDynamicText({ crumb }) {
    return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: "h200", className: "ml-5 text-silver-90 p-2" }, { children: (0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ href: crumb.href }, { children: crumb.label })) })) })));
}
exports.BreadcrumbDynamicText = BreadcrumbDynamicText;
//# sourceMappingURL=BreadcrumbDynamicText.js.map